import type { LabelHierarchy } from '../../types';

export function getAllParentLabelIds(
  hierarchyItems: LabelHierarchy[],
  parentIds = new Set<number>(),
): Set<number> {
  for (const item of hierarchyItems) {
    if (item.child_labels && item.child_labels.length > 0) {
      parentIds.add(item.label_id);
      getAllParentLabelIds(item.child_labels, parentIds);
    }
  }

  return parentIds;
}

export function getAllChildLabelIds(
  hierarchyItems: LabelHierarchy[],
  childIds = new Set<number>(),
): Set<number> {
  for (const item of hierarchyItems) {
    if (!item.child_labels || item.child_labels.length === 0) {
      childIds.add(item.label_id);
    } else {
      getAllChildLabelIds(item.child_labels, childIds);
    }
  }

  return childIds;
}
